/*
 * @Author: Liux
 * @Date: 2019-09-24 07:49:12
 * @LastEditor: Liux
 * @LastEditTime: 2020-10-09 15:22:25
 */
import {
  Component,
  OnInit,
  Input,
  forwardRef,
  EventEmitter,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ad-text',
  templateUrl: './ad-text.component.html',
  styleUrls: ['./ad-text.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdTextComponent),
      multi: true,
    },
  ],
})
export class AdTextComponent implements OnInit, ControlValueAccessor {
  _value: any;
  focused: boolean;
  @Input() disabled: boolean;
  @Input() multiple = false;
  @Input() height: string; // use for textarea
  @Input() resizeable = true; // use for textarea
  @Input() iconClass: any;
  @Input() iconPosition = 'left';
  @Input() width: string;
  @Input() placeholder = '';
  @Output() onIconClick = new EventEmitter();
  @Output() onKeyUp = new EventEmitter();
  @Output() onFocus = new EventEmitter();
  @Output() onBlur = new EventEmitter();
  @Input() showButtonBorder = false;
  @Input() maxlength = 99999999;
  valueOnChange = (v: any) => {};
  valueOnTouch = () => {};
  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.valueOnChange(val);
  }

  focus(event) {
    this.focused = true;
    this.onFocus.emit(event);
  }

  blur(event) {
    this.focused = false;
    this.onBlur.emit(event);
    this.valueOnTouch();
  }

  keyUp(event) {
    this.onKeyUp.emit(event);
  }

  writeValue(obj: any): void {
    this._value = obj;
  }
  registerOnChange(fn: any): void {
    this.valueOnChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.valueOnTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  constructor() {}

  ngOnInit() {}
}
